/*------------------------------------*\
    BABEL POLYFILL
\*------------------------------------*/
import 'babel-polyfill';

/*------------------------------------*\
    MODULES
\*------------------------------------*/
import TypeMate from 'typemate';
import AOS from 'aos';
import HomeHero from './modules/home-hero';
import Map from './modules/map';
import SiteNav from './modules/site-nav';
import PasswordStrength from './modules/password-strength';

// Bootstrap
import $ from "jquery";
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/collapse';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {
    init() {
        this.noJs();
        this.alwaysLoad();
        this.nodelistPolyfill();
        this.bind();
    },

    bind() {
        // Load any items that need modules
        let modulePlaceHolders = [
            ...document.querySelectorAll('[data-module]')
        ];

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map(item => {
            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map(module => {
                switch (module) {
                    case 'home-hero':
                        let homeHeroInstance = new HomeHero(item);

                        homeHeroInstance.init();

                        break;

                    case 'map':
                        let mapInstance = new Map(item);

                        mapInstance.init();

                        break;

                    case 'site-nav':
                        let siteNavInstance = new SiteNav(item);

                        siteNavInstance.init();

                        break;

                    case 'password-strength':
                        let passwordStrengthInstance = new PasswordStrength(item);

                        passwordStrengthInstance.init();

                        break;
                }
            });
        });
    },

    alwaysLoad() {
        const typeMateInstance = new TypeMate();
        typeMateInstance.apply();

        AOS.init({
            once: true
        });

        // Remove preload class from body on page load
        // (fixes this Chromium bug: https://bugs.chromium.org/p/chromium/issues/detail?id=332189)
        document.querySelector('body').classList.remove('preload');
    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    },

    nodelistPolyfill() {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
    }
};

// Launch
app.init();
